// 全局变量 __ENV__, __MOCK__, __API_PREFIX__

const config = {
  apiPrefix: __API_PREFIX__,
};

export default config;
